import React, { useEffect, useState } from 'react';
import { X, CaretLeft, CaretRight } from '@phosphor-icons/react';
interface OfferPhotoGridProps {
  photos: string[];
}
export function OfferPhotoGrid({
  photos
}: OfferPhotoGridProps) {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  // Lock body scroll when lightbox is open
  useEffect(() => {
    if (lightboxIndex === null) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightboxIndex(null);
      if (e.key === 'ArrowLeft') handlePrev();
      if (e.key === 'ArrowRight') handleNext();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', handleKey);
    };
  }, [lightboxIndex]);
  if (!photos || photos.length === 0) return null;
  const displayPhotos = photos.slice(0, 4);
  const hasMore = photos.length > 4;
  const moreCount = photos.length - 4;
  const openLightbox = (e: React.MouseEvent, index: number) => {
    e.stopPropagation();
    setLightboxIndex(index);
  };
  const handlePrev = () => {
    setLightboxIndex(prev => prev === null ? null : prev === 0 ? photos.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setLightboxIndex(prev => prev === null ? null : prev === photos.length - 1 ? 0 : prev + 1);
  };
  return <>
      {/* Compact strip — height matches OfferListingPreview thumb (80-96px) */}
      <div className="grid grid-cols-4 gap-2" data-id="element-641">
        {displayPhotos.map((photo, index) => {
        const isLast = index === 3;
        return <button key={index} onClick={e => openLightbox(e, index)} className="relative h-20 sm:h-24 rounded-lg overflow-hidden group cursor-pointer" data-id="element-642">
              <img src={photo} alt={`Photo ${index + 1}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-643" />
              {isLast && hasMore && <div className="absolute inset-0 bg-dark-1/60 flex items-center justify-center" data-id="element-644">
                  <span className="text-base font-semibold text-light-1" data-id="element-645">
                    +{moreCount}
                  </span>
                </div>}
            </button>;
      })}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && <div className="fixed inset-0 z-[100] flex items-center justify-center" role="dialog" aria-modal="true" data-id="element-646">
          {/* Backdrop with blur */}
          <div className="absolute inset-0 bg-dark-1/80 backdrop-blur-md animate-in fade-in duration-200" onClick={() => setLightboxIndex(null)} data-id="element-647" />

          {/* Close button */}
          <button onClick={() => setLightboxIndex(null)} className="absolute top-4 right-4 p-2 text-light-3 hover:text-light-1 bg-dark-2/70 hover:bg-dark-2 rounded-full transition-colors z-10" aria-label="Închide" data-id="element-648">
            <X size={24} weight="bold" data-id="element-649" />
          </button>

          {photos.length > 1 && <>
              <button onClick={e => {
          e.stopPropagation();
          handlePrev();
        }} className="absolute left-4 p-3 text-light-3 hover:text-light-1 bg-dark-2/70 hover:bg-dark-2 rounded-full transition-colors z-10" aria-label="Anterior" data-id="element-650">
                <CaretLeft size={24} weight="bold" data-id="element-651" />
              </button>
              <button onClick={e => {
          e.stopPropagation();
          handleNext();
        }} className="absolute right-4 p-3 text-light-3 hover:text-light-1 bg-dark-2/70 hover:bg-dark-2 rounded-full transition-colors z-10" aria-label="Următor" data-id="element-652">
                <CaretRight size={24} weight="bold" data-id="element-653" />
              </button>
            </>}

          {/* Image container */}
          <div className="relative w-full h-full p-4 sm:p-12 flex items-center justify-center z-[1]" onClick={() => setLightboxIndex(null)} data-id="element-654">
            <img src={photos[lightboxIndex]} alt={`Photo ${lightboxIndex + 1}`} className="max-w-full max-h-full object-contain rounded-lg" onClick={e => e.stopPropagation()} data-id="element-655" />
          </div>

          <div className="absolute bottom-4 left-0 right-0 text-center text-sm text-light-3 z-10" data-id="element-656">
            {lightboxIndex + 1} / {photos.length}
          </div>
        </div>}
    </>;
}